/**
 * Normalize axios / FastAPI error payloads to a single safe string suitable
 * for `toast.error()`.
 *
 * FastAPI returns `detail` as a string for HTTPException(detail="...")
 * but as an ARRAY of validation-error objects for Pydantic rejections.
 * Passing the array to sonner crashes React with
 * "Objects are not valid as a React child".
 *
 * Use this helper in every catch block that surfaces a backend error.
 */
export const extractErrorMessage = (err, fallback = 'Error inesperado') => {
  if (!err) return fallback;
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (typeof first === 'string') return first;
    if (first && typeof first.msg === 'string') return first.msg;
  }
  if (typeof err?.response?.data === 'string') return err.response.data;
  if (typeof err?.message === 'string') return err.message;
  return fallback;
};
